/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

// import Types from '../../../common/modules/types';

const isNotBorder = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'BORDER',
]);

export default [
  ...[
    ['FieldRadio', {
      label: null,
      name: 'border_style',
      initialValue: 'SOLID',
      block: true,
      choices: ['Solid', 'Dashed', 'Dotted'].map(label => ({
        value: label.toUpperCase(),
        label,
      })),
    }],
    getFilterWithCol(['FieldText', {
      label: null,
      name: 'border_width',
      prefix: 'Width:',
      type: 'number',
      align: 'right',
      addonAfter: 'px',
    }], 12),
    getFilterWithCol(['FieldColorPicker', {
      label: null,
      name: 'border_color',
      prefix: 'Color:',
      useAlpha: true,
    }], 12),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotBorder, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
